// In your config.js file
export default {
    //  api: 'http://192.168.1.108',
     api: window.location.origin
 }

